var React = require('react');

function Browse (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","transform":"translate(1 1)"},[React.createElement("path",{"d":"M11 0v3M22 11h-3M18.778 18.778l-2.121-2.121M11 22v-3M0 11h3M3.222 3.222l2.121 2.121","key":0}),React.createElement("circle",{"cx":"11","cy":"11","r":"11","key":1}),React.createElement("path",{"d":"M9 9l8-4-4 8-8 4z","key":2})])));
}

Browse.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Browse;

Browse.default = Browse;
